import React from 'react';

import './SurfaceCard.css';

export interface SurfaceCardProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  /** Extra class(es) appended to the root element */
  className?: string;
  /** Padding preset. Default: "lg" */
  padding?: 'none' | 'md' | 'lg';
  /** Render as a flex column with gap between children. Default: false */
  stack?: boolean;
  /** HTML element to render. Default: "div" */
  as?: React.ElementType;
  /** Native `type` attribute — only meaningful when `as="button"`. */
  type?: string;
}

export const SurfaceCard: React.FC<SurfaceCardProps> = ({
  children,
  className,
  padding = 'lg',
  stack = false,
  as: Tag = 'div',
  ...rest
}) => {
  const cls = [
    'fb-surface-card',
    `fb-surface-card--pad-${padding}`,
    stack && 'fb-surface-card--stack',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Tag className={cls} {...rest}>
      {children}
    </Tag>
  );
};
